import { useContext } from 'react'
import { OpeningElementsControllerContext } from '@/contexts'

export const useOpeningElementsControllerContext = () => {
  const context = useContext(OpeningElementsControllerContext)

  if (!context) throw new Error('El componente OpeningElementsControllerContext debe estar envuelto por OpeningElementsControllerContextProvider')

  return context
}
